export enum TransactionType {
  CAPITALS = 1,
  CASH = 3,
  FUNDS = 25,
  DIVIDENDS = 31,
}

export enum SubTransactionType {
  ALL = 0,
  DEPOSITS = 8,
  RETREATS = 9,
  PAYMENTS = 2394,
  ISR = 3590,
  DIVIDENDS_DEPOSIT = 1,
  TRANSFERS_OUT = 3535,
  TRANSFERS_IN = 3534,
  THIRD_PARTIES = 3867,
}

export enum CashOperationType {
  ALL = 0,
  DEPOSITS = 1,
  RETREATS = 2,
}

export enum SubTransactionConcept {
  INTEREST_PAYMENT_COUPON = 'Pago de Intereses de Cupon',
}
